import { Avatar, Dialog, Divider, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { AppColors } from '../Utils/helper/AppColors';
import { Popover } from 'antd';
import UserThumbnail from './User/UserThumbnail';

const MAX_USERS = 6;

export default function UsersList({ users }) {
	console.log(users);
	const [showAll, setShowAll] = useState(false);
	return (
		<Stack direction="row" alignItems="center">
			{users.slice(0, MAX_USERS).map((u,idx) => {
				return (
					<Popover content={<UserThumbnail user={u} />}>
						<Stack  ml={ idx !== 0 ? -2.4 : 0} 
						// sx={{  boxShadow:  ` -30px 0px 4px 0px #00000040 `, borderRadius: '50%' }}
						>
							<UserThumbnail thumbnail user={u} hideName />
						</Stack>
					</Popover>
				);
			})} 
			{users?.length > MAX_USERS && (
				<Typography
					onClick={() => setShowAll(!showAll)}
					sx={{
						ml : 1,
						fontSize: 14,
						fontWeight: 400,
						lineHeight: '150%',
						fontFamily: 'Poppins',
						cursor: 'pointer',
						color: AppColors.TEXT_TERTIARY,
					}}
				>
					+{users?.slice(MAX_USERS).length} Other Members
				</Typography>
			)}

			<Dialog PaperProps={{ sx: { borderRadius: 3 } }} open={showAll} onClose={() => setShowAll(false)}>
				<Stack p={2} width={350} gap={3}>
					<Typography variant="subtitle1" fontSize={16}>
						All Users
					</Typography>
					<Stack maxHeight="50vh" overflow="scroll" gap={1} divider={<Divider />}>
						{users?.map((u, index) => (
							<UserThumbnail user={u} key={index} />
						))}
					</Stack>
				</Stack>
			</Dialog>
		</Stack>
	);
}
